import React, { useCallback, useEffect, forwardRef, useState } from 'react';
import { navigate } from 'gatsby';

import { Menu, MenuList, Box, useDisclosure } from '@chakra-ui/react';

import {
  RootMenuItem,
  CollectionMenuItem,
  EndMenuItem
} from '@components/atoms/nav/MenuItemTypes';

import dataLayerPush from '@helpers/dataLayerPush';
import { stringToId } from '@helpers/stringFormatters';

const NavDrop = forwardRef(({ menuItem, show, navWidth }, ref) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [ctaFocused, setCtaFocused] = useState(false);
  const [containText, setContaintext] = useState(false);

  const mainButtonIsExternal = menuItem.attributes.target === `_blank`;

  useEffect(() => {
    if (show) onClose();
  }, [show, onClose]);

  useEffect(() => {
    setContaintext(navWidth > 900);
  }, [navWidth]);

  const handleNavigate = useCallback((url, title, navLevel) => {
    dataLayerPush({
      event: `nav_button_click`,
      interaction: {
        click_text: title,
        link_url: url,
        nav_level: navLevel || 1
      }
    });
    navigate(url);
  }, []);

  const handleCTAClicked = useCallback(
    (url, title, navLevel) => {
      if (ctaFocused) {
        handleNavigate(url, title, navLevel);
      }
    },
    [handleNavigate, ctaFocused]
  );

  const handleCTAFocused = useCallback(() => setCtaFocused(true), []);
  const handleCTABlur = useCallback(() => setCtaFocused(false), []);

  return (
    <Menu isOpen={isOpen} onClose={onClose}>
      <RootMenuItem
        ref={ref}
        isOpen={isOpen}
        menuItemData={menuItem}
        containText={containText}
        onOpen={onOpen}
        onClose={onClose}>
        {menuItem.attributes.title}
      </RootMenuItem>
      {menuItem.attributes.children.data.length > 0 && (
        <MenuList
          role="menu"
          borderRadius="xs"
          border="none"
          boxShadow="lg"
          mt="7"
          ml="6"
          pt="2.5"
          position="relative">
          <Box
            width="0"
            height="0"
            borderLeft="10px solid transparent"
            borderRight="10px solid transparent"
            borderBottom="10px solid #fff"
            position="absolute"
            top="-10px"
            left="10%"
          />

          {menuItem.attributes.children.data.map((link, index) => (
            <CollectionMenuItem // eslint-disable-next-line react/no-array-index-key
              key={`${stringToId(link.attributes.title)}-${index}`}
              index={index}
              url={link.attributes.url}
              target={link.attributes.target}
              isOpen={isOpen}
              onClick={
                () => handleNavigate(link.attributes.url, link.attributes.title)
                // eslint-disable-next-line react/jsx-curly-newline
              }>
              {link.attributes.title}
            </CollectionMenuItem>
          ))}

          <EndMenuItem
            mainButtonIsExternal={mainButtonIsExternal}
            menuItemData={menuItem}
            isOpen={isOpen}
            onFocus={handleCTAFocused}
            onBlur={handleCTABlur}
            onCTAClicked={handleCTAClicked}
          />
        </MenuList>
      )}
    </Menu>
  );
});

export default NavDrop;
